export { ArtistAttribution } from './ArtistAttribution';
